// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/displaced-threshold.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/displaced-threshold/displaced-threshold.js';

mount([g0]);
